import { computed, onBeforeMount } from 'vue'

import { useHomepageStore } from '@/stores/homepageComponents'

export const fetchAdvantagesStore = () => {
  const homepageStore = useHomepageStore()

  onBeforeMount(async () => {
    await homepageStore.fetchAllHomepageComponents()
  })
}

export const useAdvantagesDataHeading = () => {
  const homepageStore = useHomepageStore()
  return computed(() => homepageStore.getHomepageData?.carditemswrapper?.heading)
}
export const useAdvantagesDataDescription = () => {
  const homepageStore = useHomepageStore()
  return computed(() => homepageStore.getHomepageData?.carditemswrapper?.description)
}

export const useAdvantagesDataItems = () => {
  const homepageStore = useHomepageStore()
  return computed(() => homepageStore.getHomepageData?.carditemswrapper?.carditemrepeater)
}
